import SHA256 from 'crypto-js/sha256'

export function sha256(string: string): string {
  const out = SHA256(string)
  const hash = out.toString()
  return hash
}
